import Repository from "./Repository";
import {
  RoleList,
  Role,
  RoleAdminPermissionList,
  RoleAdminPermission,
  RoleMembers,
} from "./types/Roles";
const resource = "/roles";

export default {
  getAdminRoles(roleId: string) {
    return Repository.get<RoleAdminPermissionList>(`${resource}/${roleId}`);
  },
  updateAdminRoles(roleId: string) {
    return Repository.patch<RoleAdminPermission>(`${resource}/${roleId}`);
  },
  getRoleList(accountId: string) {
    return Repository.get<RoleList>(`${resource}?accountId=${accountId}`);
  },
  createRole(requestBody: Role) {
    return Repository.post<Role>(`${resource}`, requestBody);
  },
  updateRole(roleId: string, requestBody: Role) {
    return Repository.patch<Role>(`${resource}/${roleId}`, requestBody);
  },
  updateRoleMembers(roleId: string, requestBody: RoleMembers) {
    return Repository.post<Role>(`${resource}/${roleId}/members`, requestBody);
  },
  getRole(roleId: string) {
    return Repository.get<Role>(`${resource}/${roleId}`);
  },
};
